<template>
  <div class="app-container">
    <div>
      <header class="header">
        <h1 class="header-title">
          <a href="/"> vue-instantsearch-app </a>
        </h1>
        <p class="header-subtitle">
          using
          <a href="https://github.com/algolia/vue-instantsearch">
            Vue InstantSearch
          </a>
        </p>
      </header>

      <div class="container">
        <ais-instant-search
          :search-client="searchClient"
          index-name="instant_search"
        >
          <div class="search-panel">
            <div class="search-panel__filters">
              <ais-refinement-list attribute="brand" />
            </div>

            <div class="search-panel__results">
              <div class="searchbox">
                <ais-search-box placeholder="" />
              </div>
              <ais-hits>
                <template v-slot:item="{ item }">
                  <article>
                    <h1>
                      <ais-highlight :hit="item" attribute="name" />
                    </h1>
                    <p>
                      <ais-highlight :hit="item" attribute="description" />
                    </p>
                  </article>
                </template>
              </ais-hits>

              <div class="pagination">
                <ais-pagination />
              </div>
            </div>
          </div>
        </ais-instant-search>
      </div>
    </div>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
import { ref } from "vue";

export default {
  components: {},
  async setup() {
    const searchClient = ref(null);

    const res = await algoliasearch(
      "latency",
      "6be0576ff61c053d5f9a3225e2a90f76"
    );

    searchClient.value = res;

    return {
      searchClient,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}
.search-panel {
  display: flex;
}
.search-panel__filters {
  flex: 1;
}
.search-panel__results {
  flex: 3;
}
.searchbox {
  margin-bottom: 2rem;
}
.pagination {
  margin: 2rem auto;
  text-align: center;
}
</style>
